// Stub module: the admin app exposes a full aiRequest GraphQL surface
// (createAiRequest, executeAiRequest, etc.) plus a `aiSparkAiRequestBuilder`
// helper. The webapp_contextstory project does not currently surface these
// APIs. Ported components (PreviewFile/FilesPanel) reference them only for the
// optional "Generate summary with AI" flow. Each stub throws a clear error so
// the user sees a toast instead of a cryptic undefined-call crash.
const notSupported = (name) => () => {
  const err = new Error(
    `${name} is not available in this build. AI summary generation is disabled.`
  );
  return Promise.reject(err);
};

export const apiCreateAiRequest = notSupported("apiCreateAiRequest");
export const apiExecuteAiRequestV2 = notSupported("apiExecuteAiRequestV2");
export const apiGetAiRequests = async () => ({ aiRequests: [], total: 0 });

export const aiSparkAiRequestBuilder = {
  build: () => {
    throw new Error(
      "aiSparkAiRequestBuilder is not available in this build."
    );
  },
};

export default {
  apiCreateAiRequest,
  apiExecuteAiRequestV2,
  apiGetAiRequests,
  aiSparkAiRequestBuilder,
};
